import React from "react";
import Modal from "react-modal";
import { toast } from "react-toastify";
import CircularProgress from "@mui/material/CircularProgress";
import { deleteApi, getApi, postApi } from "../Services/apiService";

function DeleteConfirmationModal({
    isOpen,
    onClose,
    itemDetails,
    itemType = "profile",
    onSuccess
}) {
    const [loading, setLoading] = React.useState(false);

    // Reset loading state when modal opens/closes
    React.useEffect(() => {
        if (isOpen) {
            setLoading(false);
        }
    }, [isOpen]);

    const handleDelete = async () => {
        setLoading(true);
        try {
            let response;

            // Fallback to POST if your API requires it
            response = await deleteApi(`/delete-family-member/${itemDetails.id}`);


            if (response?.statusCode === 200 || response?.success) {
                toast.success(`${itemType.charAt(0).toUpperCase() + itemType.slice(1)} deleted successfully`);
                onSuccess?.(itemDetails.id);
                onClose(true);
            } else {
                toast.error(`Failed to delete ${itemType}`);
                onClose(false);
            }
        } catch (error) {
            console.error(`Error deleting ${itemType}:`, error);
            toast.error(`Failed to delete ${itemType}`);
            onClose(false);
        } finally {
            setLoading(false);
        }
    };

    const getItemName = () => {
        return itemDetails?.name || itemDetails?.title || itemDetails?.email || "this item";
    };

    const getItemTypeDisplay = () => {
        const types = {
            profile: "Profile",
            event: "Event",
            member: "Family Member",
            user: "User",
            // Add more types as needed
        };
        return types[itemType] || itemType;
    };

    return (
        <>
            <button className="profile-modal-close" onClick={() => onClose(false)}>
                ×
            </button>

            <h2 className="profile-modal-title">Delete {getItemTypeDisplay()}</h2>

            <div className="profile-delete-content">
                {/* <div className="profile-warning-icon">
                    <img src="/assets/images/warning-icon.svg" alt="Warning" />
                </div> */}

                <p className="profile-delete-message">
                    Are you sure you want to delete <strong>this</strong>?
                    This action cannot be undone.
                </p>

                {itemType === "profile" && (
                    <div className="profile-delete-warning">
                        <p>Deleting your profile will:</p>
                        <ul>
                            <li>Remove all data & delete from family tree.</li>
                            {/* <li>Remove all your spouse information</li>
                            <li>Remove you from family tree</li> */}
                        </ul>
                    </div>
                )}

            </div>

            <div className="profile-modal-actions">
                <button
                    type="button"
                    className="profile-btn-cancel"
                    onClick={() => onClose(false)}
                    disabled={loading}
                >
                    Cancel
                </button>
                <button
                    type="button"
                    className="profile-btn-delete"
                    onClick={handleDelete}
                    disabled={loading}
                >
                    {loading ? (
                        <CircularProgress size={20} color="inherit" />
                    ) : (
                        `Delete ${getItemTypeDisplay()}`
                    )}
                </button>
            </div>
        </>
    );
}

export default DeleteConfirmationModal;